import { render } from "./AttendanceMonitoring.vue?vue&type=template&id=8d56b0cc"
import script from "./AttendanceMonitoring.vue?vue&type=script&lang=ts"
export * from "./AttendanceMonitoring.vue?vue&type=script&lang=ts"

import "./AttendanceMonitoring.vue?vue&type=style&index=0&id=8d56b0cc&lang=css"
script.render = render

export default script